import React, { createContext, useContext, useState, useCallback } from 'react'
import type { MLWidgetSettings } from '../interfaces'

interface MLWidgetContextType {
  settings: MLWidgetSettings | undefined | null
  updateSettings(newSettings: Partial<MLWidgetSettings>): void
}

const MLWidgetContext = createContext<MLWidgetContextType | undefined>(
  undefined,
)

export const MLWidgetProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [settings, setSettings] = useState<MLWidgetSettings | null | undefined>(
    null,
  )

  const updateSettings = useCallback(
    (newSettings: Partial<MLWidgetSettings>) => {
      setSettings(prevSettings => ({
        ...prevSettings,
        ...newSettings,
      }))
    },
    [],
  )

  return (
    <MLWidgetContext.Provider value={{ settings, updateSettings }}>
      {children}
    </MLWidgetContext.Provider>
  )
}

export const useMLWidgetContext = () => {
  const context = useContext(MLWidgetContext)
  if (context === undefined) {
    throw new Error('useMLWidgetContext must be used within a MLWidgetProvider')
  }
  return context
}
